import { init_instantBook } from "../instantBook_integration";
import { sponsoredStaySuggestion_click_log } from "../log";
import { getLimit, initializeTooltips } from "./general_util";
import { addReviewDisplay_expandedCard } from "./review_scripts";
import { get_camp_info_reviews } from "./socialMedia_api";
import { init_staySelectionListeners } from "../tripPlanner_new/eventListeners/customEventListeners"

export function disp_ALLcampData(camp_id: number,legIndex:number,stopIndex:number,campCard:HTMLElement){
	get_camp_info_reviews(camp_id).then(response => {
		addReviewDisplay_expandedCard(response.reviews);

		$('#campExpandedModal #info').html(response.infoHTML);

		const is_tripPlanner:boolean = window.location.pathname == "/tripPlanner" || window.location.pathname == "/tripPlanner";
		init_instantBook(is_tripPlanner);

		$('#campExpandedModal #info').attr("leg",legIndex);
		$('#campExpandedModal #info').attr("stop", stopIndex);
		$('#campExpandedModal #info').attr("campID",camp_id);

		if (window.location.pathname.includes('/tripPlanner') || window.location.pathname.includes('/tripPlanner')) {
			init_staySelectionListeners()
			if ($(campCard).attr("unaddedstay") != undefined) {
				let modal:JQuery<HTMLElement> = $("#campExpandedModal");
				let addStayButton:JQuery<HTMLElement> = modal.find("[add-stay-to-stop]");
				let selectStaysMenu:JQuery<HTMLElement> = $("#stopPopout");
				// let legIndex:number = parseInt(selectStaysMenu.attr("leg"));
				let stopID:string = selectStaysMenu.attr("stopid");
				let campID:number = parseInt($(campCard).attr("id"));

				addStayButton.append(`<h6 class="mb-0" style="color:#000;font-weight: 600;text-decoration:underline;">Add</h6>`);
				addStayButton.removeClass("d-none");
				addStayButton.attr("stopID",stopID);
				addStayButton.attr("campID",campID);

				$("#compatibilityIcon").on("click",function() {
					$("#compatibilityModal").modal("show");
				});

				if ($(campCard).attr("sponsoredStaySuggestion") == "true") {
					let sponsoredEventId:string = $(campCard).attr("sponsoredEventId");
					let campPageLink:JQuery<HTMLElement> = modal.find("[campPageLink]");
					let externalCampPageLink:JQuery<HTMLElement> = modal.find("[campgroundUrl]");
					let reserveBtn:JQuery<HTMLElement> = modal.find("[campReserveBtn]");
					let instantBookBtn:JQuery<HTMLElement> = modal.find("#cgCardInstantBookButton");

					externalCampPageLink.off("click");
					reserveBtn.off("click");
					instantBookBtn.off("click");

					if (campPageLink.length > 0) {
						campPageLink.attr("href", campPageLink.attr("href") + `?spsid=${sponsoredEventId}`);
					};
					sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "openPopup");
					externalCampPageLink.on("click", ()=>{sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "websiteLink")});
					reserveBtn.on("click", ()=>{sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "reserveLink")});
					instantBookBtn.on("click", ()=>{sponsoredStaySuggestion_click_log(sponsoredEventId, campID, "instantBook")});
				};
			};
		};

		initializeTooltips();

		if($("#expCampCardAddStayBtn").attr('add-stay-to-stop') !== undefined){
			if ($(campCard).find("[add-camp-disabled]").length !== 0) {
				$("#expCampCardAddStayBtn").parent().addClass("d-none");
			} else {
				getLimit(['staySelection', 'addLimit']).then((addStayMaxAmountData) => {
					let addStayMaxAmount = addStayMaxAmountData[0];
					//only check loop if you need to | TODO
					let count:number = 0;
					if (addStayMaxAmount != "inf") {
						window.tripPlannerCurrentTrip.legs.forEach(leg => {
							leg.clusters.forEach(cluster => {
								count += cluster.selectedCamps.length
							});
						});

						if (typeof(addStayMaxAmount) == "string") addStayMaxAmount = parseInt(addStayMaxAmount);

						if(count >= addStayMaxAmount){
							let msg:string = "To add more campgrounds to your trip,";
							$("#expCampCardAddStayBtn").removeAttr("add-stay-to-stop");
							$("#expCampCardAddStayBtn").attr("msg", msg);
							$("#expCampCardAddStayBtn").attr("tieredFeature", "tieredFeature");
							$("#expCampCardAddStayBtn").attr("popupTrigger", addStayMaxAmountData[1])
						};
					}
				});
			};
		};

		$("#campExpandedModal").modal("show");

	});
}